import React from 'react';

function Home() {
  return (
    <div style={styles.container}>

      {/* Main Heading */}
      <h1 style={styles.heading}>Happy 1-Year Anniversary, My Love! </h1>

      {/* Heart Animation */}
      <div style={styles.heart}>&#10084;</div>

      {/* Sweet Message */}
      <p style={styles.message}>
        This past year with you has been the most amazing journey. From saying yes to me in a parking lot, to all of the little
        moments in between, every second with you has been a treasure. I can't wait to celebrate many more
        years with you. I love you forever and ever and always!
      </p>

      {/* Button to Explore the Website */}
      <a href="/timeline" style={styles.button}>
        Explore Our Story
      </a>
    </div>
  );
}

export default Home;

// Styles
const styles = {
  container: {
    textAlign: 'center',
    padding: '20px',
    background: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontFamily: "'Dancing Script', cursive, sans-serif",
  },
  heart: {
    fontSize: '100px',
    animation: 'beat 1.5s infinite',
  },
  heading: {
    fontSize: '48px',
    margin: '20px 0',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
  },
  message: {
    fontSize: '24px',
    maxWidth: '600px',
    lineHeight: '1.6',
    margin: '20px 0',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
  },
  button: {
    marginTop: '20px',
    padding: '10px 20px',
    fontSize: '20px',
    color: '#fff',
    background: '#ff6f61',
    borderRadius: '50px',
    textDecoration: 'none',
    boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
    transition: 'background 0.3s ease',
  },
  '@keyframes beat': {
    '0%, 100%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.2)',
    },
  },
};
